import(/* webpackMode: "eager", webpackExports: ["CourseOverviewClient"] */ "/vercel/path0/app/course/[slug]/CourseOverviewClient.tsx");
